import { render, staticRenderFns } from "./mediapage.vue?vue&type=template&id=17f98626&scoped=true&"
import script from "./mediapage.vue?vue&type=script&lang=js&"
export * from "./mediapage.vue?vue&type=script&lang=js&"
import style0 from "./mediapage.vue?vue&type=style&index=0&id=17f98626&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f98626",
  null
  
)

export default component.exports